import React from 'react';
import Icon from '../AppIcon';
import Button from '../ui/Button';

const LocationPermissionPrompt = ({ isOpen, onRequestPermission, onManualEntry, onClose }) => {
  if (!isOpen) return null;

  const handleRequestPermission = () => {
    if (navigator.geolocation) {
      navigator.geolocation?.getCurrentPosition(
        (position) => {
          onRequestPermission && onRequestPermission({
            latitude: position?.coords?.latitude,
            longitude: position?.coords?.longitude
          });
        },
        (error) => {
          console.error('Konum izni hatası:', error);
          onManualEntry && onManualEntry();
        }
      );
    } else {
      onManualEntry && onManualEntry();
    }
  };

  return (
    <div className="fixed inset-0 z-2000 flex items-center justify-center p-4 bg-background">
      <div className="w-full max-w-md bg-card rounded-2xl shadow-xl p-8 space-y-6">
        <div className="flex justify-center">
          <div className="flex items-center justify-center w-16 h-16 bg-primary/10 rounded-full">
            <Icon name="MapPin" size={32} color="var(--color-primary)" />
          </div>
        </div>

        <div className="text-center space-y-3">
          <h2 className="text-2xl font-bold text-foreground font-heading">
            Konumunuza İhtiyacımız Var
          </h2>
          <p className="text-muted-foreground">
            Size en yakın dolmuş duraklarını ve varış sürelerini gösterebilmek için konumunuza erişmemiz gerekiyor.
          </p>
        </div>

        <div className="space-y-4 pt-2">
          <div className="flex items-start gap-3">
            <div className="flex items-center justify-center w-6 h-6 bg-success/10 rounded-full flex-shrink-0 mt-0.5">
              <Icon name="Check" size={14} color="var(--color-success)" />
            </div>
            <div>
              <p className="text-sm font-medium text-foreground">Gerçek Zamanlı Varış Süreleri</p>
              <p className="text-xs text-muted-foreground">Konumunuza göre en doğru tahminler</p>
            </div>
          </div>

          <div className="flex items-start gap-3">
            <div className="flex items-center justify-center w-6 h-6 bg-success/10 rounded-full flex-shrink-0 mt-0.5">
              <Icon name="Check" size={14} color="var(--color-success)" />
            </div>
            <div>
              <p className="text-sm font-medium text-foreground">Yakındaki Duraklar</p>
              <p className="text-xs text-muted-foreground">Size en yakın durakları bulun</p>
            </div>
          </div>

          <div className="flex items-start gap-3">
            <div className="flex items-center justify-center w-6 h-6 bg-success/10 rounded-full flex-shrink-0 mt-0.5">
              <Icon name="Check" size={14} color="var(--color-success)" />
            </div>
            <div>
              <p className="text-sm font-medium text-foreground">Güvenli ve Özel</p>
              <p className="text-xs text-muted-foreground">Konumunuz sadece cihazınızda saklanır</p>
            </div>
          </div>
        </div>

        <div className="space-y-3 pt-4">
          <Button
            variant="default"
            fullWidth
            onClick={handleRequestPermission}
            iconName="MapPin"
            iconPosition="left"
          >
            Konumu Paylaş
          </Button>

          <Button
            variant="outline"
            fullWidth
            onClick={onManualEntry}
            iconName="Search"
            iconPosition="left"
          >
            Manuel Konum Gir
          </Button>

          {onClose && (
            <Button
              variant="ghost"
              fullWidth
              onClick={onClose}
              className="text-muted-foreground"
            >
              Şimdi Değil
            </Button>
          )}
        </div>

        <p className="text-xs text-center text-muted-foreground pt-2">
          Konum izninizi istediğiniz zaman tarayıcı ayarlarından değiştirebilirsiniz.
        </p>
      </div>
    </div>
  );
};

export default LocationPermissionPrompt;